

export const calculateDiscount = (cTotal: number, dVal: number): { amount: number; total: number; } => {
    const discountAm = (cTotal * dVal) / 100;
    const sum = (cTotal - Math.round(discountAm));

    return {
        amount: discountAm,
        total: sum
    };
};

